// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationIncreaseLoyaltyPath = 'M46.281 15.813A26.145 26.145 0 009.673 53.148l4.695 4.522L9.69 75.742l31.336 8.114.124-.478 9.002 8.626 40.421-38.922.336-.339a26.062 26.062 0 007.4-18.182 26.04 26.04 0 00-7.698-18.485l-.31-.3c-10.262-9.798-26.48-9.698-36.613.293l-3.555 3.554-3.525-3.49-.327-.32zm-3.118 59.8l6.977 6.684 35.54-34.22a19.04 19.04 0 005.625-13.082l.005-.434c0-5.076-2.027-9.94-5.621-13.508-7.421-7.316-19.29-7.403-26.799-.278l-.27.26-8.462 8.463-.08-.08-.013.074a9.66 9.66 0 00-10.775 6.321l8.566 11.285a6.847 6.847 0 011.167 5.862l-1.688 6.505-2.321 9.004-1.852 7.143zm.479-52.566l-1.97-1.95A19.145 19.145 0 009.65 29.706c-1.731 6.481.058 13.385 4.651 18.166l.274.279 1.807 1.74 1.309-5.055a6.89 6.89 0 013.865-4.547l10.533-4.638a16.655 16.655 0 0111.554-12.603zM22.165 55.48l.009-.009-.005-.005 2.278-8.802 10.71-4.716 7.074 9.318-1.673 6.446-2.322 9.006-2.231 8.608-17.784-4.606 3.944-15.24zm10.765-.619a3.93 3.93 0 100-7.86 3.93 3.93 0 000 7.86z';
var IllustrationIncreaseLoyalty = baseIllustration('IllustrationIncreaseLoyalty', {
  getPath: () => IllustrationIncreaseLoyaltyPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationIncreaseLoyalty;
//# sourceMappingURL=index.js.map